import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f5abbee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "radio-button-group ml-4" }
const _hoisted_2 = { class: "radio" }
const _hoisted_3 = ["name", "value"]
const _hoisted_4 = { class: "radio-elmt mt-2 mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
], -1))
const _hoisted_6 = { class: "radio-text" }
const _hoisted_7 = { class: "ml-4" }
const _hoisted_8 = {
  key: 0,
  class: "input-box col-6"
}
const _hoisted_9 = { class: "input-label" }
const _hoisted_10 = ["onUpdate:modelValue", "onInput"]
const _hoisted_11 = {
  key: 1,
  class: "input-box col-12"
}

export function render(_ctx, _cache) {
  const _component_Popover = _resolveComponent("Popover")
  const _component_RadioButtonHorizontal = _resolveComponent("RadioButtonHorizontal")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radiobutton-subquestions", _ctx.validForm() ? 'answered' : ''])
  }, [
    _createElementVNode("h4", null, [
      _createTextVNode(_toDisplayString(_ctx.newWording) + " ", 1),
      _createVNode(_component_Popover, { popover: _ctx.obj }, null, 8, ["popover"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.responses, (option) => {
        return (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: _ctx.uniqueIdName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedOption) = $event)),
            value: option.value
          }, null, 8, _hoisted_3), [
            [_vModelRadio, _ctx.selectedOption]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(option.wording), 1)
          ])
        ]))
      }), 256))
    ]),
    (_ctx.selectedOption == _ctx.question.subQuestionTriggerValue && _ctx.question.atcsSubQuestions?.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.question.atcsSubQuestions, (sq, i) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (sq.atcsQuestionTypeId == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("h5", _hoisted_9, _toDisplayString(sq.wording) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": $event => ((_ctx.question.atcsSubQuestions[i].responses[0].answerTxt) = $event),
                    onInput: $event => (_ctx.updateSubQuestionAnswer($event, i))
                  }, null, 40, _hoisted_10), [
                    [_vModelText, _ctx.question.atcsSubQuestions[i].responses[0].answerTxt]
                  ])
                ]))
              : _createCommentVNode("", true),
            (sq.atcsQuestionTypeId == 10)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_RadioButtonHorizontal, {
                    class: "one-lineOptions",
                    question: _ctx.question.atcsSubQuestions[i],
                    "onUpdate:question": $event => ((_ctx.question.atcsSubQuestions[i]) = $event),
                    allQuestions: sq.atcsSubQuestions,
                    "onUpdate:allQuestions": $event => ((sq.atcsSubQuestions) = $event),
                    onValidForm: _cache[1] || (_cache[1] = $event => (_ctx.validSubForm()))
                  }, null, 8, ["question", "onUpdate:question", "allQuestions", "onUpdate:allQuestions"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      : _createCommentVNode("", true)
  ], 2))
}